export const countriesService = {
  getCountries () {
    return axios.get('countries')
      .then(res => {
        return res
      })
  },
  getCurrencies () {
    return axios.get('currencies')
      .then(res => {
        return res
      })
  }
}
